module.exports = __webpack_public_path__ + "img/diablo-calzone.782d3948.jpg";